import React, { Component } from 'react'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import './Stores.css'
import { Modal } from 'react-bootstrap'
import Api from '../../Api'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { confirmAlert } from 'react-confirm-alert'
import { connect } from 'react-redux'
import { mergeClosePopup } from '../../actions/modalAction'
import Draggable from 'react-draggable'
import { Config } from '../../Config'
import { CommonConstants } from '../../Constants'
import CommonStoreMethods from './CommonStoreMethod'

// StoreMerge (Admin) - Component.
class StoreMerge extends Component {
  constructor (props) {
    super(props)
    this.api = new Api()
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      data: {},
      DeviceData: {},
      show: false,
      deviceSelected: [],
      storeSelected: null,
      error: [],
      message: '',
      isSuccess: false,
      isvalid: true,
      // Merge request data.
      sourceDeviceUids: [],
      targetSuid: null,
      targetDeviceUids: null,
      storeUID: ''

    }
    this.handleShow = this.handleShow.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }
  reInit () {
    this.setState({
      data: {},
      DeviceData: {},
      show: false,
      deviceSelected: [],
      storeSelected: null,
      error: [],
      message: '',
      isSuccess: false,
      isvalid: true,
      sourceDeviceUids: [],
      targetSuid: null,
      targetDeviceUids: null,
      storeUID: ''
    })
  }
  // Close button function
  handleClose () {
    this.reInit()
    this.props.dispatch(mergeClosePopup())
  }

  // Show button function
  handleShow () {
    this.setState({ show: true })
  }
  // check is device select  or not and check some conditions
  selectSystemChecked (value) {
    let contains = this.state.deviceSelected.includes(this.props.storesDetails.storePopupDetails.Device_Details[value])
    if (!contains) {
      this.state.deviceSelected = [...this.state.deviceSelected, this.props.storesDetails.storePopupDetails.Device_Details[value]]
    } else {
      this.state.deviceSelected = this.state.deviceSelected.filter(function (el) {
        return el.Device_MainVersion !== this.props.storesDetails.storePopupDetails.Device_Details[value].Device_MainVersion
      })
    }
  }

  // set the state in storeSelected
  targetStoreChecked (value) {
    if (value != null) {
      let DeviceData = this.state.DeviceData
      let storeUID = DeviceData.storeList[value].Store_UID
      this.setState({ storeSelected: this.state.DeviceData.storeList[value], storeUID })
    } else {
      this.setState({ storeSelected: null })
    }
  }
  removeDublicatesDeviceUIDs () {
    let deviceSelected = this.state.deviceSelected
    if (deviceSelected && deviceSelected.length > 0) {
      deviceSelected = this.state.deviceSelected.filter((device, index, self) =>
        index === self.findIndex((item) => (
          item.Device_UID === device.Device_UID
        ))
      )
      this.setState({ deviceSelected: deviceSelected })
    }
  }

  // API call for seach the store
  SearchApi (serialNumber) {
    if (serialNumber) {
      let error = []
      this.setState({ storeSelected: null, storeUID: '' })
      const language = this.state.currentLanguage
      let url = Config.apiBaseUrl + CommonConstants.apiUrls.getStores + '?isAdmin=1&criteria=' + serialNumber + '&filter=Store_Number&psize=0&pno=0'
      this.api.getData(url, result => {
        if (result.status) {
          if (result.pageDetails.RecordCount && result.pageDetails.RecordCount > 0) {
            this.setState({ DeviceData: result, error: [], isvalid: true })
          } else {
            error.push(t[language].NoRecordsFound)
            this.setState({ error: error, isvalid: false, DeviceData: {} })
          }
        } else {
          error.push(t[language].NoRecordsFound)
          this.setState({ error: error, isvalid: false, DeviceData: {} })
        }
      })
    }
  }
  // ConfirmMerge function
  ConfirmMerge () {
    let error = []
    const language = this.state.currentLanguage
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.saveMergeDevices
    let targetDeviceUids = []
    for (var device of this.state.storeSelected.Device_Details) {
      targetDeviceUids.push(device.Device_UID)
    }
    targetDeviceUids = targetDeviceUids.join(',')
    let data = {
      sourceDeviceUids: this.state.sourceDeviceUids,
      targetSuid: this.state.params.suids,
      targetDeviceUids: targetDeviceUids

    }
    this.api.postData(url, data, result => {
      if (result.status) {
        this.setState({ error: [], isvalid: true, isSuccess: true })
        this.setState({ DeviceData: {} })
        this.reInit()
        this.props.dispatch(mergeClosePopup())
      } else {
        error.push(t[language].MergeTargetStoreOffline)
        this.setState({ error: error, isvalid: false })
      }
    })
  }

  isTargetStoreHasDeviceAssociated () {
    let isDeviceAssociated = false
    if (this.state.storeSelected) {
      let targetStores = this.state.storeSelected
      for (var device of targetStores.Device_Details) {
        if (device && device.Device_UID) {
          isDeviceAssociated = true
        }
      }
    }
    return isDeviceAssociated
  }
  checkIsTargetStoreOffline () {
    if (this.state.storeSelected) {
      let targetStores = this.state.storeSelected
      for (var device of targetStores.Device_Details) {
        if (device && device.Device_IsActive === 0) {
          return true
        }
      }
      return false
    }
  }
  // MergeClick function
  MergeClick () {
    this.setState({ error: [], isvalid: true })
    let error = []
    const language = this.state.currentLanguage
    let duid = []
    let sourceDeviceUids = []
    this.removeDublicatesDeviceUIDs()
    if (this.state.deviceSelected.length !== 0 && this.state.storeSelected != null) {
      if (this.isTargetStoreHasDeviceAssociated()) {
        if (this.checkIsTargetStoreOffline()) {
          for (var p of this.state.deviceSelected) {
            duid.push(p.Device_UID)
            sourceDeviceUids.push(p.Device_UID)
          }
          duid = duid.join(',')
          this.setState({ sourceDeviceUids: duid })
          this.state.params = {
            'suids': this.state.storeSelected.Store_UID,
            'duid': duid
          }
          // API call for merage request
          let url = Config.apiBaseUrl + CommonConstants.apiUrls.mergeDevicesInfo
          this.api.postData(url, this.state.params, data => {
          // after merage request success
            if (data.status) {
              if (data.IsCheck) {
                confirmAlert({
                  customUI: ({ onClose }) => {
                    return (
                      <Draggable>
                        <div className='custom-ui'>
                          <span className='custom-ui-header'><h1>{t[language].ConfirmationRequired} </h1></span>
                          <div className='merge-dialog-content'>
                            <p>{t[language].mergeActionRemove}</p>
                            <div className='merge-body'>
                              <p className='store-info-section'>
                                {t[language].settingsStoresStoreNumber}: <span className='greenText'>{data.deviceDetails.Store_Number}</span>
                                <br />
                                {t[language].settingsStoresSerialNumber}: <span className='greenText'>{data.deviceDetails.Device_SerialNumber}</span><br />
                                {t[language].System}: <span className='greenText'>{data.deviceDetails.Device_Name}</span>
                                <br />
                              </p>
                            </div>
                            <p className='confirmation-text'>{t[language].Mergeconfirmation}</p>
                          </div>
                          <div className='store-merge-footer'>
                            <div className='merge-footer-buttonset'>
                              <button type='button' className='rounded-corners' onClick={() => {
                                this.ConfirmMerge()
                                onClose()
                              }}>Confirm</button>
                              <button type='button' className='rounded-corners' onClick={onClose}>{t[language].cancel}</button>
                            </div>
                          </div>
                        </div>
                      </Draggable>
                    )
                  }
                })
              } else {
                //  after merage request fails and dislaying the erros
                error.push(t[language].MergeTargetStoreOffline)
                this.setState({ error: error, isvalid: false })
              }
            } else {
              //  after merage request fails and dislaying the erros
              error.push(t[language].MergeTargetStoreOffline)
              this.setState({ error: error, isvalid: false })
            }
          })
        } else {
          //  after merage request fails and dislaying the erros
          error.push(t[language].MergeTargetStoreOffline)
          this.setState({ error: error, isvalid: false })
        }
      } else {
        //  after merage request fails and dislaying the erros
        error.push(t[language].MergeTargetStoreNoDeviceAssociated)
        this.setState({ error: error, isvalid: false })
      }
    } else {
      //  Check the selected device details
      if (this.state.deviceSelected.length === 0 && this.state.storeSelected == null) {
        error.push(t[language].MustSelectStLeastOneSystem)
        error.push(t[language].MustSelectTargetStore)
        this.setState({ error: error, isvalid: false })
      } else {
        //  dislaying the erros
        (this.state.deviceSelected.length === 0) ? error.push(t[language].MustSelectStLeastOneSystem) : error.push(t[language].MustSelectTargetStore)
        this.setState({ error: error, isvalid: false })
      }
    }
  }
  //  Main Render Function
  render () {
    const language = this.state.currentLanguage
    let Show = (this.props.mergeModelPopup !== undefined) ? this.props.mergeModelPopup : false
    const populateError = (errors) => {
      return errors.map((error, i) => {
        return <li className='merge-error-message' key={i}>{error}</li>
      })
    }
    //  set the details to model popup screen
    return (
      <Modal show={Show} dialogClassName='store-merge-popup' >
        <Modal.Body className='store-merge-popup-content'>
          <div className='merge-store-wrapper'>
            <div className='merge-store-header'>
              <h2 className=''>{t[language].Merge}</h2>
            </div>
            <div className='store-merge-body'>
              <div className='merge-store-row'>

                <SelectSystem data={this.props.storesDetails.storePopupDetails} selectSystemChecked={this.selectSystemChecked.bind(this)} />
                <TargetStore
                  search={this.SearchApi.bind(this)}
                  targetStoreChecked={this.targetStoreChecked.bind(this)}
                  data={this.state.DeviceData}
                  storeUID={this.state.storeUID} />
              </div>
            </div>
          </div>
          <div className='store-merge-footer'>
            <div className='merge-store-row'>
              <div className='merger-error-block'>
                <div className={(this.state.isvalid ? 'hide' : 'show')}>
                  <ul className='merge-error-list'>
                    {populateError(this.state.error)}
                  </ul>
                </div>
                <div className={(this.state.isSuccess ? 'show' : 'hide')}>
                  <span className='merge-success-message'>{this.state.message}</span>
                </div>
              </div>
              <div className='save-merge-block text-right'>
                <a className='btn-cancel merge-cancel' onClick={this.handleClose}>{t[language].cancel}</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                <button type='button' className='btn-submit merge-submit-btn' onClick={this.MergeClick.bind(this)}>{t[language].Merge}</button>
              </div>
            </div>
          </div>
          <div className='merger-popup-close' onClick={this.handleClose}>X</div>
        </Modal.Body>
      </Modal>
    )
  }
}
//  SelectSystem Component
class SelectSystem extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage()
    }
    this.rowClicked = this.rowClicked.bind(this)
  }
  //  Select System
  rowClicked (event) {
    // let value = (event.target.checked) ? event.target.value : null
    this.props.selectSystemChecked(event.target.value)
  }
  //  display the systems and systems actions
  render () {
    const language = this.state.currentLanguage
    let displayData = this.props.data.storeDetails
    let device = this.props.data.Device_Details
    let headers = [' ', t[language].System, t[language].settingsStoresSerialNumber]
    return (
      <div className='select-system-col'>
        <h3>{t[language].SelectSystem}</h3>
        <div className='form-group'>
          <div className='store-brand-info'>
            <div>{t[language].settingsStoresStoreNumber}:&nbsp;&nbsp;<span className='merge-storenobrand-label'>{displayData.Store_Number}</span></div>
            <div>{t[language].store} {t[language].brand}:&nbsp;&nbsp;<span className='merge-storenobrand-label'>{displayData.Brand_Name}</span></div>
          </div>
        </div>
        <div className='select-system-content'>
          <Table data={device} header={headers} rowClicked={this.rowClicked} />
        </div>
      </div>
    )
  }
}

//  display Table Component for show thw system details
class Table extends Component {
  render () {
    let row = this.props.data
    let rows
    if (row) {
      rows = row.map((data, index) => {
        return (
          <tr>
            <td>
              <input type='checkbox' name='sys-merge-check' className='sys-merge-check' value={index} onClick={this.props.rowClicked} />
            </td>
            <td>
              {data.Device_Name}
            </td>
            <td>
              {data.Device_SerialNumber}
            </td>
          </tr>
        )
      })
    }
    let Header = this.props.header.map((data, index) => {
      return (
        <th key='index' className='merge_device_name'>
          {data}
        </th>

      )
    })
    return (
      <table >
        <thead>
          <tr>
            {Header}
          </tr>
        </thead>
        <tbody >
          {rows}
        </tbody>
      </table>)
  }
}

//  TargetStore Component for selected store
class TargetStore extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      serialNumber: 0
    }
    this.api = new Api()
    this.handleOnClick = this.handleOnClick.bind(this)
    this.rowClicked = this.rowClicked.bind(this)
    this.onEnterPress = this.onEnterPress.bind(this)
  }
  handleOnClick () {
    this.props.search(this.state.serialNumber)
  }
  onEnterPress (e) {
    if (e.key === 'Enter') {
      this.props.search(this.state.serialNumber)
    }
  }
  rowClicked (event) {
    let value = (event.target.checked) ? event.target.value : null
    this.props.targetStoreChecked(value)
  }
  SearchChange (event) {
    this.setState({ serialNumber: event.target.value })
  }
  render () {
    const language = this.state.currentLanguage
    // let displayData = this.props.systemStats
    let data = (this.props.data.storeList !== undefined) ? this.props.data.storeList : null
    let headers = [' ', t[language].store, t[language].company, t[language].brand]
    return (
      <div className='target-store-col'>
        <h3>{t[language].SelectTargetStore}</h3>
        <form className='form-inline target-store-search'>
          <div className='form-group target-store-group'>
            <input type='text' className='store-number-input' onChange={this.SearchChange.bind(this)} placeholder={t[language].EnterStoreNumber} />
          </div>
          <button type='button' className='btn btn-default merge-search-btn' onClick={this.handleOnClick.bind(this)} onKeyPress={this.onEnterPress.bind(this)}>{t[language].Search}</button>
        </form>
        <div className='target-results-content'>
          <TargetTable data={data} header={headers} rowClicked={this.rowClicked} storeUID={this.props.storeUID} />
        </div>
      </div>
    )
  }
}
//  TargetTable Component
class TargetTable extends Component {
  constructor (props) {
    super(props)
    this.CommonStoreMethods = new CommonStoreMethods()
  }
  renderText (text) {
    return this.CommonStoreMethods.renderText(text)
  }
  render () {
    let self = this
    let row = this.props.data
    let rows
    if (row !== null) {
      rows = row.map((data, index) => {
        return (
          <tr>
            <td>
              <input type='radio' name='sys' className='sys-merge-check' checked={data.Store_UID === self.props.storeUID} value={index} onClick={this.props.rowClicked} />
            </td>
            <td>
              {data.Store_Number}
            </td>
            <td className='tooltipText'>
              {self.renderText(data.Company_Name)}
            </td>
            <td>
              {data.Brand_Name}
            </td>
          </tr>
        )
      })
    }
    let Header = this.props.header.map((data, index) => {
      return (
        <th className='merge_device_name' style={{ width: index === 0 ? '1%' : '' }}>
          {data}
        </th>
      )
    })
    if (row) {
      return (
        <table >
          <thead>
            <tr>
              {Header}
            </tr>
          </thead>
          <tbody >
            {rows}
          </tbody>
        </table>)
    } else {
      return (
        <table >
          <thead>
            <tr>
              {Header}
            </tr>
          </thead>
          <tbody />
        </table>)
    }
  }
}

//  set the state from redux action files
function mapStateToProps (state) {
  return {
    storesDetails: state.StorePopupDetails,
    mergeModelPopup: state.StorePopupDetails.mergePopUp
  }
}
export default connect(mapStateToProps)(StoreMerge)



// WEBPACK FOOTER //
// ./src/components/Stores/StoreMerge.js